import cn from 'classnames';
import { useHeaderStore } from 'src/store';

import { engLettersArr, FilterTrigger, ruLettersArr } from '../consts';
import FilterButton from './FilterButton';
import styles from './LetterListDesktop.module.scss';
import Sticky from './Sticky';

const LetterListDesktop = ({ firstLettersArr }: { firstLettersArr: string[] }) => {
    const isFixed = useHeaderStore(({ isFixed }) => isFixed);

    return (
        <div>
            <div className={styles.titleRow}>
                <h2 className={styles.title}>Бренды</h2>
            </div>
            <Sticky>
                <div className={cn(styles.panel, isFixed && styles.panel_fixed)}>
                    <div className={styles.engRow}>
                        <div>
                            <FilterButton
                                buttonText={FilterTrigger.Numbers}
                                isSticky={isFixed}
                                available={firstLettersArr.includes(FilterTrigger.Numbers)}
                            />
                        </div>

                        {engLettersArr.map(letter => (
                            <FilterButton
                                buttonText={letter.toUpperCase()}
                                key={letter}
                                isSticky={isFixed}
                                available={firstLettersArr.includes(letter.toLowerCase())}
                            />
                        ))}
                    </div>
                    <div className={styles.ruRow}>
                        {ruLettersArr.map(letter => (
                            <FilterButton
                                buttonText={letter.toUpperCase()}
                                isSticky={isFixed}
                                key={letter}
                                available={firstLettersArr.includes(letter.toLowerCase())}
                            />
                        ))}
                    </div>
                </div>
            </Sticky>
        </div>
    );
};

export default LetterListDesktop;
